"use client";

import React from 'react';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';

type Props = {
  onClick?: () => void;
};

export default function MenuButton({ onClick }: Props) {
  return (
    <IconButton
      color="inherit"
      aria-label="open navigation"
      onClick={onClick}
      sx={{
        height: '44px',
        width: '44px',
        padding: 0,
        minWidth: 0,
        borderRadius: '50%',
        bgcolor: 'transparent',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        mr: 1,
        transition: 'transform 120ms ease, box-shadow 120ms ease, background-color 120ms ease',
        transform: { xs: 'translateY(-8px)', md: 'none' },
        '&:hover': {
          transform: { xs: 'translateY(-12px)', md: 'translateY(-2px)' },
          boxShadow: '0 3px 6px rgba(0,0,0,0.18)',
          bgcolor: 'rgba(255,255,255,0.12)',
        },
        '&.Mui-focusVisible': {
          boxShadow: '0 3px 6px rgba(0,0,0,0.18)',
          bgcolor: 'rgba(255,255,255,0.12)'
        },
      }}
    >
      <MenuIcon fontSize="small" />
    </IconButton>
  );
}
